// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryListStyles } from "@conklin/Overrides/Widgets/Category/CategoryList";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

categoryListStyles.categoryNameWrapper = {
    css: css`
        width: 100%;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

categoryListStyles.innerContainer = {
    css: css`
        row-gap: 48px;
        margin: 48px 0;
    `,
};

categoryListStyles.subCategoriesWrapper = {
    css: css`
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(148px, 1fr));
        align-items: start;
        justify-items: center;
        row-gap: 24px;
        column-gap: 22px;
        padding-top: 16px;
        ${xScreen("lte", "md")} {
            column-gap: 48px;
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            column-gap: 16px;
        }
    `,
};

categoryListStyles.subCategoryWrapper = {
    css: css`
        width: 148px;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

categoryListStyles.categoryImage = {
    css: css`
        width: 100%;
        height: 100%;
        object-fit: contain;
    `,
};

categoryListStyles.categoryName = {
    size: 16,
    weight: fontConfig.weight.bold,
    color: "text.link",
    css: css`
        line-height: 20px;
        text-align: center;
        ${ellipsis(2)};
        margin-top: 8px;
        &:hover {
            color: ${color("common.ui10")};
        }
    `,
};

categoryListStyles.imageCategoryWrapper = {
    css: css`
        min-width: 100%;
        height: 148px;
        ${xScreen("lte", "sm")} {
            height: 156px;
            > div {
                width: 100%;
            }
        }
    `,
};
